
import 'jquery';
// Import everything from autoload
import './autoload/_bootstrap.js'
// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
window.Swiper = Swiper;
// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import handleContactForm from './contactForm';
handleContactForm()
/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
window.$ = jQuery;
const closeAlert = document.querySelector('#close-alert');
if (closeAlert) {
  closeAlert.addEventListener('click', () => {
    jQuery('#reminder-alert').fadeOut()
    //   document.querySelector('#reminder-alert').remove()
  })
}


// WEBPACK FOOTER //
// ./scripts/main.js